module.exports = __webpack_public_path__ + "img/0352-bag-euro.f8fe36aa.svg";